module.exports = __webpack_public_path__ + "media/app/assets/covenants/night-fae-6e9e7a55d377452fbd2a8325b0fe8be5.png";